var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3523_9983)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FDFDFD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0591 28.1328C30.4958 27.6578 30.8188 27.1124 31.0282 26.4966C31.2374 25.8809 31.342 25.246 31.342 24.5921C31.342 23.9381 31.2374 23.3033 31.0282 22.6875C30.8188 22.0717 30.4958 21.5263 30.0591 21.0513C30.9604 21.1553 31.7087 21.5445 32.3042 22.2187C32.8994 22.8932 33.1971 23.6843 33.1971 24.5921C33.1971 25.5 32.8994 26.2911 32.3042 26.9654C31.7087 27.6397 30.9604 28.0288 30.0591 28.1328ZM35.4472 36V33.592C35.4472 33.0325 35.3334 32.5002 35.1057 31.9951C34.8781 31.49 34.555 31.0565 34.1366 30.6948C34.9235 30.9566 35.6478 31.3099 36.3096 31.7547C36.9714 32.1994 37.3023 32.8119 37.3023 33.592V36H35.4472ZM37.3023 29.2697V27.2171H35.2497V25.6777H37.3023V23.625H38.8417V25.6777H40.8944V27.2171H38.8417V29.2697H37.3023ZM25.6973 28.1842C24.7095 28.1842 23.8638 27.8325 23.1603 27.1291C22.4569 26.4256 22.1052 25.5799 22.1052 24.5921C22.1052 23.6043 22.4569 22.7587 23.1603 22.0553C23.8638 21.3518 24.7095 21 25.6973 21C26.6851 21 27.5307 21.3518 28.2341 22.0553C28.9376 22.7587 29.2894 23.6043 29.2894 24.5921C29.2894 25.5799 28.9376 26.4256 28.2341 27.1291C27.5307 27.8325 26.6851 28.1842 25.6973 28.1842ZM18 36V33.7183C18 33.2157 18.1365 32.7503 18.4095 32.322C18.6825 31.8937 19.0473 31.5644 19.5038 31.3341C20.5183 30.8369 21.5417 30.4639 22.574 30.2152C23.6061 29.9665 24.6472 29.8422 25.6973 29.8422C26.7472 29.8422 27.7883 29.9665 28.8206 30.2152C29.8527 30.4639 30.8761 30.8369 31.8906 31.3341C32.3471 31.5644 32.7119 31.8937 32.9849 32.322C33.258 32.7503 33.3946 33.2157 33.3946 33.7183V36H18Z",
    fill: "#F97000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3523_9983",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.439216 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3523_9983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3523_9983",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6);
export default __webpack_public_path__ + "static/media/step6.ebe03633fd4f868690263d797fdde7f1.svg";
export { ForwardRef as ReactComponent };